import Tippy from "@tippyjs/react";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";
import { PAGE_SIZES, STATUS, } from "../../../constants/status";
import IconImageDefault from "../../../assets/icons/ic_image_default.svg";
import { BrandCampaignFilter } from "./brand-campaign-filter";
import { PromotionBrand } from "../../../models/response/promotion-brand";
import ImageCustom from "../../../components/custom/image-custom";
import React from "react";

interface BrandCampaignTableProps {
  tableLoading: boolean;
  data: PromotionBrand[];
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  keySearch: string;
  setKeySearch: (value: string) => void;
}

export const BrandCampaignTable = (props: BrandCampaignTableProps) => {
  const {
    tableLoading,
    data = [],
    page,
    pageSize,
    setPage,
    setPageSize,
    keySearch,
    setKeySearch,
  } = props;

  const [tableMaxHeight, setTableMaxHeight] = useState(0);

  const initialRecords = data.slice(0, pageSize);
  const [recordsData, setRecordsData] = useState(initialRecords);

  useEffect(() => {
    setPage(1);
  }, [pageSize, keySearch]);

  useEffect(() => {
    const from = (page - 1) * pageSize;
    const to = from + pageSize;
    setRecordsData(data.slice(from, to));
  }, [page, pageSize, data]);

  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector(".navbar") as HTMLElement;
      const filter = document.getElementById("filter-bar") as HTMLElement;

      if (header && filter) {
        const headerHeight = header.offsetHeight;
        const filterHeight = filter.offsetHeight;
        const remainingHeight =
          window.innerHeight -
          headerHeight -
          filterHeight -
          24 -
          24 -
          40 -
          24;
        setTableMaxHeight(remainingHeight);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="panel flex flex-col gap-3">
      <BrandCampaignFilter
        searchValue={keySearch}
        setSearchValue={setKeySearch}
      />
      <div className="datatables" style={{ height: tableMaxHeight }}>
        <DataTable
          fetching={tableLoading}
          withColumnBorders
          noRecordsText="Không có kết quả nào phù hợp với truy vấn tìm kiếm"
          highlightOnHover
          className="whitespace-nowrap table-hover custom-scroll"
          records={recordsData}
          columns={[
            {
              accessor: "_id",
              title: "STT",
              width: "5%",
              textAlignment: "center",
              render: (record, index) => <div>{(page - 1) * pageSize + index + 1}</div>
            },
            // {
            //   accessor: "logo",
            //   title: "Logo",
            //   width: "5%",
            //   titleClassName: "!text-center",
            //   render: (record) => (
            //     <div className="flex justify-center items-center w-100">
            //       <ImageCustom
            //         isReview
            //         fallBackUrl={IconImageDefault}
            //         url={`${record.logo || IconImageDefault}`}
            //         isLocal={false}
            //         className="w-10 h-10 rounded-md overflow-hidden object-cover"
            //       />
            //     </div>
            //   ),
            // },
            {
              accessor: "name",
              title: "Tên thương hiệu",
              width: "40%",
              titleClassName: "!text-center",
              render: (record) => <div className="">{record.name}</div>
            },
            // {
            //   accessor: "phone",
            //   title: "Số điện thoại",
            //   width: "10%",
            //   titleClassName: "!text-center",
            //   render: (record) => <div className="">{record.phone}</div>
            // },
            {
              accessor: "promotions",
              title: "Khuyến mãi đang áp dụng",
              width: "45%",
              titleClassName: "!text-center",
              render: (record) => {
                const activePromotions = record.promotions.filter((promotion) => promotion.is_checked === STATUS.ACTIVE);
                return (
                  <div>
                    {activePromotions.map((promotion, index) => (
                      <React.Fragment key={promotion._id || index}>
                        <Tippy
                          content={<span>{promotion.description || "No description available"}</span>}
                        >
                          <span className="cursor-pointer">{promotion.name}</span>
                        </Tippy>
                        {index < activePromotions.length - 1 && ", "}
                      </React.Fragment>
                    ))}
                  </div>
                );
              }
            }
          ]}
          totalRecords={data.length}
          recordsPerPage={pageSize}
          page={page}
          onPageChange={(p) => setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={setPageSize}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) =>
            `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`
          }
        />
      </div>
    </div>
  );
};
